export interface ITermsSection {
  id: string
  title: string
  body: string
}

export const TERMS_SECTIONS: readonly ITermsSection[] = [
  {
    id: 'acceptance',
    title: '1. Acceptance of Terms',
    body: 'By accessing The Vault, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this service.',
  },
  {
    id: 'lp-access',
    title: '2. Limited Partner Access',
    body: 'Access to The Vault is restricted to verified Limited Partners of Hanwha Asset Management (USA) LTD. By proceeding, you certify that you are an authorized LP with the right to access confidential fund information, investment theses, portfolio updates, and related materials.',
  },
  {
    id: 'confidentiality',
    title: '3. Confidentiality and Data Protection',
    body: 'All information, documents, and data available through The Vault are confidential and proprietary. You agree not to disclose, distribute, or share any content with unauthorized parties. You acknowledge that Hanwha Asset Management collects and processes your data in accordance with applicable privacy regulations.',
  },
  {
    id: 'account-security',
    title: '4. Account Security',
    body: 'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must immediately notify Hanwha Asset Management of any unauthorized use of your account or any other breach of security.',
  },
  {
    id: 'regulatory',
    title: '5. Regulatory Compliance',
    body: 'This service is provided in compliance with applicable securities laws and regulations. The information provided is for informational purposes only and does not constitute investment advice, an offer to sell, or a solicitation of an offer to buy any securities.',
  },
  {
    id: 'liability',
    title: '6. Limitation of Liability',
    body: 'Hanwha Asset Management (USA) LTD shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use The Vault, even if we have been advised of the possibility of such damages.',
  },
  {
    id: 'modifications',
    title: '7. Modifications to Service',
    body: 'We reserve the right to modify, suspend, or discontinue The Vault at any time without notice. We may also update these Terms of Service periodically, and continued use of the service constitutes acceptance of any changes.',
  },
]
